'use client';

import {LocaleMessages} from '@epic-mw/i18n';
import Script from 'next/script';
import {getStaticAssetPath} from '@/lib/utils/assets';

interface Props {
	messages?: LocaleMessages;
	structuredData?: string;
	nonce: string;
}

export const FavIcons = ({messages = {}, structuredData, nonce}: Props) => {
	const title = messages['epic.app.meta.title'];

	return (
		<>
			<link
				rel="icon"
				type="image/png"
				href={getStaticAssetPath('icon-96x96.png')}
				sizes="96x96"
			/>
			<link rel="icon" type="image/svg+xml" href={getStaticAssetPath('icon.svg')} />
			<link rel="shortcut icon" href={getStaticAssetPath('icon.ico')} />
			<link
				rel="apple-touch-icon"
				sizes="180x180"
				href={getStaticAssetPath('touch-icon-180.png')}
			/>
			<link rel="manifest" href={getStaticAssetPath('site.webmanifest')} />
			<meta name="apple-mobile-web-app-title" content={title} />
			<meta name="application-name" content={title} />
			<meta name="msapplication-TileColor" content="#26bbff" />
			<meta name="theme-color" content="#ffffff" />
			<link rel="alternate" type="application/rss+xml" title={title} href="/rss" />
			{structuredData ? (
				<Script
					nonce={nonce}
					// strategy="beforeInteractiv"
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: structuredData
					}}
				/>
			) : null}
		</>
	);
};
